import * as dayjs from 'dayjs';

export default function (val, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!val) return '';
  return dayjs(val).format(format);
}
